module.exports = __webpack_public_path__ + "static/media/SF-Compact-Text-Medium.fd228d24.woff2";